const requestLog: Record<string, string> = {
    title: 'Application log № {number}',
    backToRequest: 'Go to application',
};

export default requestLog;